import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export const DeleteBatchButton = ({ batch }) => {
  const qc = useQueryClient();
  const del = useMutation({
    mutationFn: async () => (await api.delete(`/production/${batch.id}`)).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["production"] }); toast.success(`Lotto ${batch.batch_number} eliminato`); },
    onError: () => toast.error("Errore durante l'eliminazione"),
  });
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-rose-400" data-testid={`delete-batch-${batch.batch_number}`}>
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare il lotto {batch.batch_number}?</AlertDialogTitle>
          <AlertDialogDescription>
            {batch.product_name}{batch.color ? ` · ${batch.color}` : ""} · {batch.quantity} pz. L'operazione non si può annullare.
            {batch.materials_consumed && " I materiali già scaricati non verranno ricaricati in magazzino."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-batch-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={() => del.mutate()} className="bg-rose-600 hover:bg-rose-700" data-testid="delete-batch-confirm">Elimina</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
